module.exports = __webpack_public_path__ + "img/card-image-bootle-1.7d43f3ff.png";